<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="documentNotFound">
  <div class="modal-header">
    <h4 class="modal-title">Document Not Found</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!(serverError || documentNotFound)">

  <div class="modal-header">
    <h4 class="modal-title">Document Pending Staff Approval</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="!loadingDocument">

    <table>
      <tr>
        <td class="pr-3">Document Name:</td>
        <td>{{ document.document_name }}</td>
      </tr>
      <tr>
        <td class="pr-3">Document Completed At:</td>
        <td>
          {{ timeStringFromISO8601(document.document_completed_at) }},
          {{ dateStringFromISO8601(document.document_completed_at) }}
        </td>
      </tr>
      <tr>
        <td class="pr-3">Document PDF:</td>
        <td>
          <a *ngIf="document.document_pdf" [href]="document.document_pdf" target="_blank">Link</a>
          <span *ngIf="!document.document_pdf" class="text-muted">No PDF found - PDF creation may still be in progress.</span>
        </td>
      </tr>
      <ng-container *ngFor="let relatedCustomer of document.related_customers">
        <tr style="height: 10px;"></tr>
        <tr>
          <td class="pr-3">Customer Name:</td>
          <td>
            <a [routerLink]="['/customers', relatedCustomer.id.toString()]" target="_blank">
              {{ relatedCustomer.first_name }} {{ relatedCustomer.last_name }}
            </a>
          </td>
        </tr>
        <tr>
          <td class="pr-3">Birthday:</td>
          <td>{{ dateStringFromISO8601(relatedCustomer.birthday) }}</td>
        </tr>
        <tr>
          <td class="pr-3">Email Address:</td>
          <td *ngIf="relatedCustomer.email">{{ relatedCustomer.email }}</td>
          <td *ngIf="!relatedCustomer.email" class="text-muted">None given</td>
        </tr>
        <tr>
          <td class="pr-3">Telephone:</td>
          <td *ngIf="relatedCustomer.telephone">{{ relatedCustomer.telephone }}</td>
          <td *ngIf="!relatedCustomer.telephone" class="text-muted">None given</td>
        </tr>
      </ng-container>
    </table>

    <ng-container *ngIf="document.pending_account_links?.length">
      <h6 class="mt-4 mb-2">Account links to be created on approval</h6>
      <table class="table table-sm mb-0">
        <thead>
          <tr>
            <th>Adult</th>
            <th>Minor</th>
            <th>Relationship</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let link of document.pending_account_links">
            <td>
              <a [routerLink]="['/customers', link.adult.id.toString()]" target="_blank">
                {{ link.adult.first_name }} {{ link.adult.last_name }}
              </a>
            </td>
            <td>
              <a [routerLink]="['/customers', link.minor.id.toString()]" target="_blank">
                {{ link.minor.first_name }} {{ link.minor.last_name }}
              </a>
            </td>
            <td>{{ link.relation_label }}</td>
          </tr>
        </tbody>
      </table>

      <table class="mt-3">
        <tr>
          <td class="pb-2 pr-3 align-top">Information:</td>
          <td class="pb-2">{{ orgConfigService.getOrganizationConfig().customer_facing_linking_instructions }}</td>
        </tr>
        <tr>
          <td class="pr-3 align-top">Verification:</td>
          <td>{{ orgConfigService.getOrganizationConfig().staff_verification_linking_instructions }}</td>
        </tr>
      </table>
    </ng-container>

    <div class="form-check mt-4">
      <input class="form-check-input" type="radio" id="approveInput"
             [value]="StaffApprovalAction.approve" [(ngModel)]="selectedAction">
      <label class="form-check-label" for="approveInput">
        Approve document.
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" id="denyInput"
             [value]="StaffApprovalAction.deny" [(ngModel)]="selectedAction">
      <label class="form-check-label text-danger" for="denyInput">
        Deny document.
      </label>
    </div>
    <div class="form-check" *ngIf="showHideOption">
      <input class="form-check-input" type="radio" id="hideInput"
             [value]="StaffApprovalAction.hide" [(ngModel)]="selectedAction">
      <label class="form-check-label" for="hideInput">
        Dismiss from inbox.
      </label>
    </div>

    <div class="alert alert-danger mb-0 mt-3" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-body" *ngIf="loadingDocument">
    <p>Loading...</p>
  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!(loadingSubmit || loadingDocument)"
            (click)="handleSave()"
            [disabled]="!validInputSelected()"
            [class.disabled]="!validInputSelected()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit || loadingDocument">
      Loading...
    </button>

  </div>

</ng-container>
